import { render, staticRenderFns } from "./LearningPath.vue?vue&type=template&id=08919ac2&scoped=true&"
import script from "./LearningPath.vue?vue&type=script&lang=ts&"
export * from "./LearningPath.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPath.vue?vue&type=style&index=0&id=08919ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08919ac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08919ac2', component.options)
    } else {
      api.reload('08919ac2', component.options)
    }
    module.hot.accept("./LearningPath.vue?vue&type=template&id=08919ac2&scoped=true&", function () {
      api.rerender('08919ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPaths/LearningPath.vue"
export default component.exports